import React from 'react'
import Navbar from '../../components/Navbar'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next'
import filter_color from "../../assets/images/design/colorFilter.svg"
import banking from "../../assets/images/contents/banking-whitepaper.png"
import { PrimaryButton, PrimaryButton2th } from '../../components/StyledButtons'
import WhitepaperDownloadForm from './WhitepaperDownloadForm'
import OtherWhitepapers from './OtherWhitepapers'
import eu_dcc_whitepaper from "../../assets/images/contents/eudcc-whitepaper.gif"
import testing_inspection_whitepaper from "../../assets/images/contents/testing-inspection-whitepaper.png"
import document_security_2023 from "../../assets/images/contents/document-security.png"

const Banking = () => {
    const handleScroll = () => {
        const targetElement = document.getElementById('download-whitepaper-form');
        if (targetElement) {
            const yOffset = 0;
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const { t } = useTranslation()

    const items = [
        {
            id: 1,
            link: '/whitepapers/testing-inspection',
            image: testing_inspection_whitepaper,
            chip: t("whitepapers-tab.testing-inspection-whitepaper"),
            title: t('whitepapers.testing-inspection-title'),
            content: t('whitepapers.testing-inspection-content'),
        },
        {
            id: 2,
            link: '/whitepapers/document-security',
            image: document_security_2023,
            chip: t("whitepapers-tab.document-security-whitepaper"),
            title: t('whitepapers.document-security-title'),
            content: t('whitepapers.document-security-content'),
        },
        {
            id: 3,
            link: '/whitepapers/eu-dcc',
            image: eu_dcc_whitepaper,
            chip: t("whitepapers-tab.eu-dcc-whitepaper"),
            title: t('whitepapers.eudcc-title'),
            content: t('whitepapers.eudcc-content')
        },

    ];

    return (
        <div className='banking bg-primary'>
            <div className='color-filter-right' style={{ top: "45%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "55%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>

            <Navbar />
            <div className='container-fluid banking-header'>
                <div className='container pt-100 pt-md-150'>
                    <div className='col-sm-12 col-xl-7 px-md-0 pt-lg-50 pt-f768-t991-0'>
                        <p className='font-64 font-weight-semi-bold header-sub-title'>{t('whitepapers.banking.title')}</p>
                        <p className='font-60 font-weight-semi-bold header-title'>{t('whitepapers.download-whitepaper-for-free')}</p>
                        <p className='pt-30 text-white'>{t('whitepapers.banking.sub-title')}</p>
                        <div className='pt-30'>
                            <PrimaryButton onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton>
                        </div>
                    </div>
                    <div className='col-sm-12 col-xl-5 pt-50 pt-xl-0'>
                        <div className='flex justify-center' >
                            <img src={banking} alt="banking" className='img-responsive img-header' />
                            <div className='banking-behind-line'></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container pt-70'>
                <div className='look-inside col-sm-12'>
                    <div className='col-lg-5'>
                        <div className='flex justify-center'>
                            <img src={banking} alt="qr_code_1" className='img-responsive' />
                        </div>

                    </div>
                    <div className='col-lg-7'>
                        <p className='font-32 font-weight-semi-bold pt-30'>{t('whitepapers.looking-inside-the-whitepaper')}</p>
                        <p className='pt-20'>
                            {t('whitepapers.banking.content-1')}
                        </p>
                        <p className='pt-20'>
                            {t('whitepapers.banking.content-2')}
                        </p>
                        <div className='pt-20'>
                            <PrimaryButton2th onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton2th>
                        </div>
                    </div>
                </div>
            </div>

            <WhitepaperDownloadForm />

            <OtherWhitepapers items={items} />


            <div className='container'>
                <IndustriesImageContainer />
            </div>
            <Footer />
        </div>
    )
}

export default Banking